import {
  UPDATE_PROVIDER_STATUS,
  UPDATE_PROVIDER_STATUS_FAILURE,
  UPDATE_PROVIDER_STATUS_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const updateProviderStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROVIDER_STATUS:
      return { ...state, loading: true };
    case UPDATE_PROVIDER_STATUS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case UPDATE_PROVIDER_STATUS_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default updateProviderStatusReducer;
